import React from 'react';
import ProfileShell from '../../components/forms/ProfileShell';
import { SectionHeader, Field, Input, Select, Toggle, TextArea } from '../../components/forms/FormPrimitives';

const UMBRELLA_AMOUNTS = ['$1,000,000', '$2,000,000', '$3,000,000', '$5,000,000+', 'Not sure yet'];
const REASONS = [
  'General extra protection',
  'Lawsuit/liability concerns',
  'Teen drivers',
  'Rental properties',
  'Pool / trampoline / dogs',
  'High net worth protection',
  'Other',
];

const UmbrellaProfile = () => {
  const sections = [
    {
      title: 'Current Protection',
      render: (data, update) => (
        <div>
          <SectionHeader index={1} title="Your Current Protection" subtitle="Umbrella sits above your existing policies — tell us what's underneath." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Current Auto Liability Limits" testid="umb-auto"><Input value={data.current_auto_limits} onChange={(v) => update({ current_auto_limits: v })} placeholder="e.g. 100/300/100" /></Field>
            <Field label="Current Home Liability Limits" testid="umb-home"><Input value={data.current_home_limits} onChange={(v) => update({ current_home_limits: v })} placeholder="e.g. $300,000" /></Field>
            <Field label="Current Renters/Condo Coverage" testid="umb-renters"><Input value={data.current_renters_or_condo} onChange={(v) => update({ current_renters_or_condo: v })} placeholder="If applicable" /></Field>
          </div>
        </div>
      ),
    },
    {
      title: 'Risk Details',
      render: (data, update) => (
        <div>
          <SectionHeader index={2} title="Risk Details" subtitle="These help us understand your exposure." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Number of Properties" testid="umb-properties"><Input value={data.num_properties} onChange={(v) => update({ num_properties: v })} placeholder="1" /></Field>
            <Field label="Number of Vehicles" testid="umb-vehicles"><Input value={data.num_vehicles} onChange={(v) => update({ num_vehicles: v })} placeholder="2" /></Field>
          </div>
          <div className="space-y-3 mt-4">
            <Toggle value={data.teen_drivers} onChange={(v) => update({ teen_drivers: v })} label="Teen drivers in household" testid="umb-teen" />
            <Toggle value={data.has_pool} onChange={(v) => update({ has_pool: v })} label="Pool on property" testid="umb-pool" />
            <Toggle value={data.has_trampoline} onChange={(v) => update({ has_trampoline: v })} label="Trampoline on property" testid="umb-trampoline" />
            <Toggle value={data.has_rental_properties} onChange={(v) => update({ has_rental_properties: v })} label="Own rental property(ies)" testid="umb-rental" />
            <Toggle value={data.has_business} onChange={(v) => update({ has_business: v })} label="Business ownership" testid="umb-business" />
          </div>
        </div>
      ),
    },
    {
      title: 'Desired Coverage',
      render: (data, update) => (
        <div>
          <SectionHeader index={3} title="Desired Coverage" subtitle="Let's set the umbrella size that fits your needs." />
          <Field label="Desired Umbrella Amount" testid="umb-amount">
            <Select value={data.desired_umbrella} onChange={(v) => update({ desired_umbrella: v })} options={UMBRELLA_AMOUNTS} />
          </Field>
          <Field label="Main reason for umbrella coverage" testid="umb-reason">
            <Select value={data.main_reason} onChange={(v) => update({ main_reason: v })} options={REASONS} />
          </Field>
          <Field label="Anything else we should know?" testid="umb-notes">
            <TextArea value={data.profile_notes} onChange={(v) => update({ profile_notes: v })} />
          </Field>
        </div>
      ),
    },
  ];

  return (
    <ProfileShell
      coverageType="umbrella"
      sections={sections}
      personalTouchMessage="Umbrella coverage adds an extra layer above your existing policies. Complete what you can — we'll help review options."
    />
  );
};

export default UmbrellaProfile;
